export class Cidade {
  constructor() {
    this.id = 0;
    this.nome = '';
    this.uf = '';
    this.cMun = null;
  }
}
